var base = require('settings/teams/send-invitation');

Vue.component('spark-send-invitation', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/send-invitation.js